import { Component, Input, OnInit } from '@angular/core';
import { ChartData } from 'app/components/new-navigation/charts/models/ChartData';

@Component({
  selector: 'domain-user-behavior',
  templateUrl: './domain-user-behavior.html',
  styleUrls: ['./domain-user-behavior.scss']
})
export class DomainUserBehavior implements OnInit {
  @Input() data;

  lineChartData: Array<ChartData>;

  constructor() {}

  ngOnInit() {
    this.lineChartData = [
      ...this?.data?.programmaticInventory?.hours
    ].reverse();
  }
}
